export const keymap = {
  'Save': 'ctrl+s',
  'Open': 'ctrl+o',
  'New': 'ctrl+n',//not working- open new tab in the browser 
  'ToggleTerminal': '`',
  'Info': 'F1', //not working- open the help in the browser
  'ToggleOSnap': 'f3',
  'ToggleOrtho': 'f8',
  'TogglePolar': 'f10',
  'ToggleSmartGuides': 'f11'
}; 